export const POSTNORD_API_URL = process.env.POSTNORD_API_URL
export const POSTNORD_API_KEY = process.env.POSTNORD_API_KEY
